export async function sendMail({ mail, type, link, code }) {

  console.log(mail, type);

  const res = await fetch(
    "https://sendmail-2gw7h3kv7q-uc.a.run.app/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mail,
        type,
        link,
        code,
      }),
    }
  );

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err?.error || "Erro ao enviar e-mail");
  }

  console.log(res);

  return res.json();
}